import ENTITY_TYPES from "../../constants/entityTypes";
import INQUIRY_TYPES from "../../constants/inquiryTypes";

const buildingText =
  "If you are considering listing a unit in this building, StreetEasy can provide you with a price estimate or introduce you to Experts with experience selling in this building or similar buildings.";

const saleText =
  "If you are considering listing this property or a similar unit, StreetEasy can provide you with a price estimate or introduce you to Experts with experience selling in this building or similar buildings.";

const sellerLandingText =
  "StreetEasy can offer you an unbiased take on the NYC market and your home’s value. We can also connect you with top listing agents who know homes like yours — no strings attached.";

const valuationInquiryText =
  "The StreetEasy Valuation is a beta product feature intended as a starting point to determine a home's value. For questions on the StreetEasy Valuation, or to receive a custom competitive market analysis from a StreetEasy expert, send us a note below.";

const formTextForEntityType = entityType =>
  entityType === ENTITY_TYPES.sale ? saleText : buildingText;

const formText = (inquiryType, entityType) => {
  switch (inquiryType) {
    case INQUIRY_TYPES.streeteasy_valuation:
    case INQUIRY_TYPES.seller_landing_valuation:
      return valuationInquiryText;
    case INQUIRY_TYPES.seller_landing_contact:
      return sellerLandingText;
    default:
      return formTextForEntityType(entityType);
  }
};

export default formText;
